<template>
  <div class="listing flx--grow-1 bg--color-02 pb-48 pb-100--l">
    <div class="container-new">
      <top-section class="mb-32 mb-36--l" />
      <div class="listing__bottom-block">
        <div class="listing__img">
          <img
            :src="require('@/assets/img/listing/listing.svg')"
            width="100%"
            alt="listing image"
          >
        </div>
        <submit-form class="listing__forms" />
      </div>
    </div>
  </div>
</template>

<script>
import { getDefaultHeadData } from '@/lib/utils'

export default {
  name: 'Listing',
  components: {
    TopSection: () =>
      import(/* webpackMode: "eager" */ '@/components/listing/TopSection.vue'),
    SubmitForm: () =>
      import(/* webpackMode: "eager" */ '@/components/listing/SubmitForm.vue'),
  },
  head () {
    return getDefaultHeadData({
      title: this.$t('meta.listing.title'),
      description: this.$t('meta.listing.description'),
      locale: this.$i18n.locale,
    })
  },
}
</script>

<style lang="scss" scoped>
.listing {
  &__bottom-block {
    display: grid;
    grid-template-areas: 'img' 'forms';
    gap: toRem(32px);

    @include bp(l) {
      grid-template-areas: 'forms img';
      grid-template-columns: repeat(2, 1fr);
      gap: toRem(120px);
    }
  }

  &__img {
    grid-area: img;
    max-width: toRem(211px);
    width: 100%;
    margin: 0 auto;

    @include bp(l) {
      margin: 0;
      max-width: none;
      display: flex;
    }

    img {
      @include bp(l) {
        margin-top: auto;
      }
    }
  }

  &__forms {
    grid-area: forms;
    width: 100%;

    @include bp(l) {
      margin: auto 0;
    }
  }
}
</style>
